import pushModel from "@/mixin/store/api/pushModel";
import fetchModel from "@/mixin/store/api/fetchModel";

export default {
    actions: {
        fetchSaleMonthlyStat(context, data = null) {
            if (!context.state.saleMonthly.isNeedFetch) {
                return
            }

            if (data === null) {
                data = {date: null}
            }

            return pushModel(context, 'sale_monthlies/stat', data, 'updateSaleMonthly')
        },
        fetchSaleWeeklyStat(context) {
            if (context.state.saleWeekly.isNeedFetch) {
                return fetchModel(context, 'sale_weeklies/stat', null, 'updateSaleWeekly')
            }
        },
    },
    mutations: {
        updateSaleMonthly(state, data) {
            state.saleMonthly.models = data
            state.saleMonthly.isNeedFetch = false
        },
        updateSaleWeekly(state, data) {
            state.saleWeekly.models = data
            state.saleWeekly.isNeedFetch = false
        },
    },
    state: {
        saleMonthly: {
            models: [],
            isNeedFetch: true
        },
        saleWeekly: {
            models: [],
            isNeedFetch: true
        },
    },
    getters: {
        getSaleMonthly(state) {
            return state.saleMonthly.models
        },
        getSaleWeekly(state) {
            return state.saleWeekly.models
        },
    },
}
